import './counter-signer.scss'

import { PropType } from 'vue';
import Component from "vue-class-component";
import { faTrash } from '@fortawesome/free-solid-svg-icons';

import { getTranslatedString, CounterSigner as CounterSignerType, createTranslatedString } from '@skinsoft/types';

import { ReactiveVue } from "@skinsoft/reactive-vue";
import { FIELD_VALUE_UPDATED } from '@skinsoft/ui2/events';
import { COUNTER_SIGNER_UPDATED, REMOVE_COUNTER_SIGNER } from '../../../../../../busTopics';
import { TextField } from '@skinsoft/ui2/form/text-field';
import { THESAURUS_TERM_SELECTED } from '@skinsoft/ui/src/thesaurus-term-tree/thesaurus-term-tree-modal';
import ThesaurusTermTree from '@skinsoft/ui/src/thesaurus-term-tree';

@Component({
    components: {
        sTextField: TextField,
        sThesaurusTermTree: ThesaurusTermTree,
    },
    props: {
        counterSigner: {
            type: Object as PropType<CounterSignerType>,
        },
        readOnly: {
            type: Boolean,
            default: false,
        },
        canBeDeleted: {
            type: Boolean,
        },
    },
    template: require('./counter-signer.html')
})
export class CounterSigner extends ReactiveVue {
    
    private counterSigner: CounterSignerType

    private minusIcon = faTrash

    private FIELD_VALUE_UPDATED = FIELD_VALUE_UPDATED
    private THESAURUS_TERM_SELECTED = THESAURUS_TERM_SELECTED

    private onTranslatedStringUpdated(path: string, value: string): CounterSignerType {
        let updatedSigner: CounterSignerType = {...this.counterSigner}
        if(updatedSigner[path]?.translatedString) {
            updatedSigner[path].translatedString[this.$i18n.locale] = value
        } else {
            updatedSigner[path] = createTranslatedString(this.$i18n.locale, value)
        }
        return updatedSigner
    }

    private getSignerName() {
        return getTranslatedString(this.counterSigner.surnameFirstName, this.$i18n.locale)
    }

    private onNameUpdated(name: string) {
        let updatedSigner: CounterSignerType = this.onTranslatedStringUpdated('surnameFirstName', name)
        this.updateSigner(updatedSigner)
    }

    private getSignerFunction() {
        return this.counterSigner.function
    }

    private onFunctionUpdated(signerFunction: string) {
        let updatedSigner: CounterSignerType = {...this.counterSigner}
        updatedSigner.function = signerFunction
        this.updateSigner(updatedSigner)
    }

    private updateSigner(updatedSigner: CounterSignerType) {
        this.$emit(
            COUNTER_SIGNER_UPDATED, 
            updatedSigner
        )
    }

    private deleteSigner() {
        this.$emit(
            REMOVE_COUNTER_SIGNER,
            this.counterSigner.index
        )
    }
}